import styled from 'styled-components';
import { Dialog, DialogContent } from '@mui/material';

import { mixins, fonts, media } from '../../css';

export const StyledCloseButtonWrapper = styled.span`
  cursor: pointer;
  padding-left: 10px;
  figure {
    cursor: pointer;
  }
`;

export const StyledHeader = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'fullContent'
})`
  ${({ fullContent }) =>
    fullContent &&
    `position: absolute;
`};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${({ fullContent }) => (fullContent ? mixins.pxToRem(5) : mixins.pxToRem(24))};
  padding-bottom: ${({ fullContent }) => (fullContent ? 0 : mixins.pxToRem(10))};
  width: 100%;
  z-index: 10;
  flex-wrap: wrap;
`;

export const StyledTitle = styled.div`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(18)};
`;

export const StyledSubTitle = styled.div`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(10)};
  flex-basis: 100%;
`;

export const StyledDialog = styled(Dialog)`
  && {
    [class^='MuiPaper-root'] {
      ${media.lessThan('md')`
        ${({ smallmodal }) =>
          smallmodal === 'false' &&
          `margin: 0;
          width: 100%;
          height: 100%;
          max-height: 100%;
        `};
      `};
    }
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  font-family: ${fonts.fontRegular};
  &.fullContent {
    padding: 0;
  }
  &.noOverflow {
    overflow: visible !important;
  }
`;
